export default __webpack_public_path__ + "static/media/3.0aa4733c.jpg";